/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */
/* eslint-disable no-unused-vars */
// eslint-disable-next-line import/prefer-default-export
export class BaseSocialFeedAdapter {
    /**
     * Get feed data.
     * @param {object} args The feed request object.
     * @returns void
     */
    getFeedData({ maxItems }) {
        throw new Error(`Method not implemented`);
    }
}
